function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  stroke: "#CCC",
  strokeWidth: 2,
  d: "M39 49V10.414L29.586 1H1v48h38z"
}), React.createElement("path", {
  fill: "#CCC",
  fillRule: "nonzero",
  d: "M4 4h4v2H4V4zm6 0h4v2h-4V4zm13 0h4v2h-4V4zM29 1l5 5 5 5H29z"
}), React.createElement("circle", {
  cx: 24,
  cy: 33,
  r: 7,
  fill: "#CCC",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 24,
  cy: 33,
  r: 5,
  fill: "#FFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#CCC",
  fillRule: "nonzero",
  d: "M27 37.414L28.416 36l7.07 7.071-1.413 1.414zM6 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26-3h4v2h-4v-2zm-22 0h20v2H10v-2zM6 23a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26-3h4v2h-4v-2zm-22 0h20v2H10v-2zM6 29a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm4-3h7v2h-7v-2zM6 35a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm4-3h5v2h-5v-2z"
}));

var SvgNoOptionsIcon = function SvgNoOptionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoOptionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noOptionsIcon.b34c5734.svg";
export { ForwardRef as ReactComponent };